var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.count !== 60? 'grayFont' : '',on:{"click":_vm.getPhoneVerify}},[_vm._v(_vm._s(_vm.codeText))])
}
var staticRenderFns = []

export { render, staticRenderFns }